import { DownloadProvider } from '../components/download/context/DownloadContext';
import DownloadView from '../components/download/DownloadView';

const Dashboard = () => (
    <DownloadProvider>
        <DownloadView />
    </DownloadProvider>
);

export default Dashboard;
